// 効果測定受験前のパスコードチェック & 端末時刻セット
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () => {
  const form = document.getElementById('student-practice-passcode-modal');
  const submitButton = document.getElementById('passcode-modal-submit-button');

  if (!form) return;

  submitButton.addEventListener('click', (_e) => {
    const clientTimeField = document.getElementById('modal_client_time');
    clientTimeField.value = Date.now();
    submitButton.setAttribute('disabled', true);

    const spinner = submitButton.querySelector('span');
    spinner.classList.remove('d-none');

    // MEMO: Chromeはformのsubmitが発火しないので明示的に発火させる
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    form.submit();
  });
};
